exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".RouteSplitter-f55ca9c7{height:100%}.RouteSplitter-f55ca9c7 .controls-fa2aba3b{background-color:#eee;color:#757575;padding:1em;padding-left:.5em;text-align:left;font-size:14px;cursor:pointer}.RouteSplitter-f55ca9c7 .header-22ca9ceb{background-color:#6982FF;color:#FAFAFA;padding:1em;text-align:center;font-size:16px}.RouteSplitter-f55ca9c7 .helpText-d04358c0{padding:1em}\n", ""]);

// Exports
exports.locals = {
	"RouteSplitter": "RouteSplitter-f55ca9c7",
	"controls": "controls-fa2aba3b",
	"header": "header-22ca9ceb",
	"helpText": "helpText-d04358c0"
};